export const MobileUserInfo = {
  methods: {
    isDesktop() {
      if (device.mobile()) {
        return true;
      } else {
        return false;
      }
    },
    getUser() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      // var cardHolderInfId = user.cardHolderInfId;
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            if (result.partners != null && result.isDVIP == 0) {
              this.partner = true;
            }
            if (result.isDVIP === 1 && result.dvip_TYPE == "Y") {
              this.isdvip = true;
            }
            if (result.isEmployee == 0) {
              this.nomin = false;
            }
            this.user = result;
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch(() => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
  created() {
    var return_value = this.isDesktop();
    if (!return_value) {
      this.$router.push("/profile");
    } else {
      this.getUser();
    }
  },
};
